import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsLeftChevron: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7 1h9L9 8l7 7H7L0 8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsLeftChevron
